
import { useState } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "What age groups do you accept?",
      answer: "We accept players from ages 4 to 17, with programs specifically designed for different age groups: Little Kickers (4-5), Youth Development (6-8), Skill Building (9-13), and Elite Training (14-17)."
    },
    {
      question: "What equipment does my child need?",
      answer: "Players need soccer cleats, shin guards, and comfortable athletic clothing. We provide soccer balls, training equipment, and team jerseys. A water bottle is also recommended for all training sessions."
    },
    {
      question: "How often are training sessions?",
      answer: "Training frequency varies by program: Recreational (2x/week), Competitive (3x/week), and Elite Training (4x/week). Each session is 90 minutes long and includes skill development, tactical training, and scrimmages."
    },
    {
      question: "Do you offer trial sessions?",
      answer: "Yes! We offer a free trial session for new players to experience our coaching style and meet the team. Contact us to schedule your trial session at any time during the season."
    },
    {
      question: "What is your coach-to-player ratio?",
      answer: "We maintain small group sizes to ensure personalized attention: 1:8 for ages 4-8, 1:12 for ages 9-13, and 1:15 for ages 14-17. All our coaches are licensed and have extensive playing and coaching experience."
    },
    {
      question: "Do you participate in leagues and tournaments?",
      answer: "Yes, our Competitive and Elite programs participate in local and regional leagues. We also organize internal tournaments and attend select tournaments throughout the year to provide game experience."
    },
    {
      question: "What happens in bad weather?",
      answer: "We have indoor facilities available for training during inclement weather. If outdoor sessions must be cancelled, we'll notify parents via email and our mobile app at least 2 hours before the session."
    },
    {
      question: "Can parents watch training sessions?",
      answer: "Parents are welcome to watch training sessions from designated viewing areas. We encourage parent involvement and provide regular updates on player progress through our parent communication app."
    },
    {
      question: "Do you offer goalkeeper training?",
      answer: "Yes, specialized goalkeeper training is included in our Competitive and Elite programs. We have dedicated goalkeeper coaches who work with players on technique, positioning, and game situations."
    },
    {
      question: "What is your refund and cancellation policy?",
      answer: "We offer full refunds within the first two weeks of registration. After that, pro-rated refunds are available for medical reasons with proper documentation. Monthly payments can be paused for extended absences."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-600">
            Find answers to common questions about our soccer programs and registration process.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-500 transition-transform w-6 h-6 flex items-center justify-center ${
                  openFAQ === index ? 'transform rotate-180' : ''
                }`}></i>
              </button>
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-purple-50 rounded-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Still Have Questions?</h3>
            <p className="text-gray-600 mb-6">
              Our team is here to help! Contact us for more information about our programs or to schedule a facility tour.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Contact Us
              </button>
              <button className="border-2 border-purple-600 text-purple-600 hover:bg-purple-600 hover:text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Schedule Tour
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
